import {config} from '../../config/app-config';
import {apiGet} from "../../utils/api";
import {loadContentForNewElements} from '../content-editor-src';
import {isAuthenticated} from '../auth';

let currentSlideIndex = 0;
let expertisesData = [];
let isAnimating = false;
let diagnosticSlugMap = {}; // blockId → diagnostic slug

// Функция для проверки размера экрана
function isMobile() {
    return window.innerWidth < 768;
}

const ICON_LOGO_SVG = `<svg class="icon-logo" viewBox="0 0 431 485" fill="none" xmlns="http://www.w3.org/2000/svg"><style>@keyframes bml-draw-contour{0%{stroke-dashoffset:1;fill-opacity:0;animation-timing-function:linear}65%{stroke-dashoffset:0;fill-opacity:0;animation-timing-function:ease-out}100%{stroke-dashoffset:0;fill-opacity:1}}@keyframes bml-hex-pop{0%{fill-opacity:0;transform:scale(.15)}55%{fill-opacity:.9;transform:scale(1.12)}80%{fill-opacity:1;transform:scale(.96)}100%{fill-opacity:1;transform:scale(1)}}.bml-icon-main{stroke:#0083A7;fill:#0083A7;stroke-width:4;fill-opacity:0;stroke-dasharray:1;stroke-dashoffset:1;animation:bml-draw-contour 1.6s both}.bml-icon-hex{fill:#EBFBFF;fill-opacity:0;transform-box:fill-box;transform-origin:center;animation:bml-hex-pop .45s cubic-bezier(.34,1.56,.64,1) both}.bml-icon-h1{animation-delay:.7s}.bml-icon-h2{animation-delay:.9s}.bml-icon-h3{animation-delay:1.1s}</style><path class="bml-icon-hex bml-icon-h1" d="M265.326 294.606V353.78L214.142 383.366L162.956 353.78V294.606L214.142 265.02L265.326 294.606Z"/><path class="bml-icon-hex bml-icon-h2" d="M132.979 59.9346V119.108L81.7939 148.694L30.6094 119.108V59.9346L81.7939 30.3477L132.979 59.9346Z"/><path class="bml-icon-hex bml-icon-h3" d="M404.753 59.9346V119.108L353.568 148.694L302.383 119.108V59.9346L353.568 30.3477L404.753 59.9346Z"/><path class="bml-icon-main" pathLength="1" d="M431 44.7598V134.278L362.061 174.128V254.39H344.076V173.552L283.851 138.739L222.634 174.124V239.573L291.573 279.424V368.942L214.141 413.702L145.942 374.28L86.2432 408.788V484.999H68.2598V408.344L0 368.889L8.99414 353.301L77.6357 392.978L136.706 358.833V279.424L204.649 240.149V173.669L147.862 140.844L81.7891 179.038L4.35547 134.278V44.7598L81.7891 0L159.223 44.7598V126.624L214.036 158.309L276.133 122.414V44.7598L353.567 0L431 44.7598ZM154.69 289.813V358.552L214.14 392.915L273.589 358.552V289.813L214.14 255.449L154.69 289.813ZM22.3398 55.1494V123.888L81.7881 158.251L141.238 123.888V55.1494L81.7881 20.7852L22.3398 55.1494ZM294.117 55.1494V123.888L353.566 158.251L413.016 123.888V55.1494L353.566 20.7852L294.117 55.1494Z"/></svg>`;

// Clone-replace to restart SVG internal CSS animations
function initIconLogoAnimations() {
    document.querySelectorAll('.icon-logo').forEach(icon => {
        icon.replaceWith(icon.cloneNode(true));
    });
}

function triggerIconLogoAnimation() {
    const icon = document.querySelector('.icon-logo');
    if (icon) icon.replaceWith(icon.cloneNode(true));
}

async function loadDiagnosticSlugs(blocks) {
    const results = await Promise.allSettled(
        blocks
            .filter(block => block.block_id != null)
            .map(block =>
                apiGet(`${config.api.paths.diagnosticsByBlockId}/${block.block_id}`, { auth: false })
                    .then(data => ({ contentId: block.id, slug: data?.slug || null }))
                    .catch(() => ({ contentId: block.id, slug: null }))
            )
    );
    diagnosticSlugMap = {};
    results.forEach(r => {
        if (r.status === 'fulfilled' && r.value.slug) {
            diagnosticSlugMap[r.value.contentId] = r.value.slug;
        }
    });
}

export async function initExpertisesBlocks() {
    try {
        // In admin mode, block system handles rendering of editable blocks
        const expertisesBlocks = await apiGet(`${config.api.paths.contentExpertise}`);
        console.log(`[Expertise]`, expertisesBlocks);

        if (expertisesBlocks && expertisesBlocks.length > 0) {
            expertisesData = expertisesBlocks;
            const contents = expertisesBlocks.map(block => block.content);

            await loadDiagnosticSlugs(expertisesBlocks);

            if (isMobile()) {
                renderMobileExpertiseList(expertisesData);
            } else {
                renderExpertiseSlider(expertisesData, contents);
                initSliderControls();
            }

            initIconLogoAnimations();
        }
    } catch (error) {
        console.error('Error initializing expertises blocks:', error);
    }
}

// Функция для рендера мобильной версии (все блоки подряд)
function renderMobileExpertiseList(expertisesBlocks) {
    const expertisesSection = document.querySelector('.expertises-section');
    if (!expertisesSection) {
        console.error('Expertises section not found');
        return;
    }

    // Очищаем секцию
    expertisesSection.innerHTML = '';

    // Создаем контейнер
    const containerDiv = document.createElement('div');
    containerDiv.className = 'expertise-slider-container';

    // Создаем блоки для каждой экспертизы с теми же классами
    expertisesBlocks.forEach(block => {
        const expertiseSlide = document.createElement('section');
        expertiseSlide.className = 'expertise-slide expertise-container container-fluid';
        //language=HTML
        const mobileSlug = diagnosticSlugMap[block.id] || null;
        const mobileLearnMoreHref = mobileSlug ? `/diagnostic/${mobileSlug}` : '#';
        const mobileLearnMoreClass = mobileSlug ? 'expertise-learn-more active' : 'expertise-learn-more inactive';

        expertiseSlide.innerHTML = `
            <div class="row h-100">
                <div class="slide-bar d-flex justify-content-between">
                    ${ICON_LOGO_SVG}
                </div>
                <div class="col-lg-6 d-flex flex-column justify-content-between">
                    <div class="row slide-content">
                        <h3 id="expertise-title">${block.content}</h3>
                        <p id="expertise-description" data-content="expertise_description_${block.id}"
                           data-page="expertise"
                           data-type="textarea"
                           data-attribute="html">
                        </p>
                        <a href="${mobileLearnMoreHref}" class="${mobileLearnMoreClass}">Дізнатися більше</a>
                    </div>
                    <div class="slide-content">
                        <div class="slide-content">
                            <img class="image-main-expertise"
                                 data-content="expertise_main_image_${block.id}"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 src="">
                        </div>
                        <div class="expertise-inner-image-container d-flex justify-content-center">
                            <img class="expertise-inner-image" data-content="expertise_inner_image_1_${block.id}"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 src="">
                            <img class="expertise-inner-image" data-content="expertise_inner_image_2_${block.id}"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 src="">
                        </div>
                    </div>
                </div>
            </div>
        `;

        containerDiv.appendChild(expertiseSlide);
    });

    expertisesSection.appendChild(containerDiv);

    // Инициализируем контент-редактор для новых элементов
    const newElements = expertisesSection.querySelectorAll('[data-content]');
    if (newElements.length > 0) {
        loadContentForNewElements(Array.from(newElements));
    }
}

function renderExpertiseSlider(expertisesBlocks, contents) {
    const expertisesSection = document.querySelector('.expertises-section');
    if (!expertisesSection) {
        console.error('Expertises section not found');
        return;
    }

    // Очищаем секцию
    expertisesSection.innerHTML = '';

    // Создаем один статичный контейнер
    const sliderContainer = createStaticSliderContainer(expertisesBlocks, contents);
    expertisesSection.appendChild(sliderContainer);

    // Инициализируем контент-редактор для новых элементов
    const newElements = expertisesSection.querySelectorAll('[data-content]');
    if (newElements.length > 0) {
        loadContentForNewElements(Array.from(newElements));
    }
}

function createStaticSliderContainer(expertisesBlocks, contents) {
    const containerDiv = document.createElement('div');
    containerDiv.className = 'expertise-slider-container';

    // Берем первый слайд как активный
    const firstBlock = expertisesBlocks[0];
    const firstSlug = diagnosticSlugMap[firstBlock.id] || null;
    const firstLearnMoreHref = firstSlug ? `/diagnostic/${firstSlug}` : '#';
    const firstLearnMoreClass = firstSlug ? 'expertise-learn-more active' : 'expertise-learn-more inactive';

    containerDiv.innerHTML = `
        <section class="expertise-slide expertise-container container-fluid">
            <div class="row h-100">
                <div class="col-lg-6 col-md-6 d-flex justify-content-between">
                    <div class="slide-bar d-flex flex-column h-100">
                            <div class="d-flex align-items-center flex-grow-1 h-75">
                            <ul class="expertises-name-slider" data-slide-nav="true">
                                ${contents.map((item, i) => `
                                    <li class="slider-bar-element ${i === 0 ? 'active' : ''}" data-slide-index="${i}">
                                        <div class="slider-element-wrapper">
                                            <span class="expertise-slider-name">${item}</span>
                                            <div class="active-indicator">
                                                <svg width="10" height="11" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <ellipse cx="9.34415" cy="10.0001" rx="5.47013" ry="5.57143" fill="#0090B8" />
                                                    <ellipse cx="9.34515" cy="10" rx="8.83636" ry="9" stroke="#0090B8" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </li>
                                `).join('')}
                            </ul>
                        </div>
                    </div>
                    <div class="slide-content" id="main-image-container">
                        <img class="image-main-expertise"
                             data-content="expertise_main_image_${firstBlock.id}"
                             data-page="expertise"
                             data-type="image"
                             data-attribute="image"
                             src="">
                    </div>
                </div>
                <div class="expertise-description-container col-lg-6 col-md-6 d-flex flex-column justify-content-between">
                    <div class="row slide-content" id="content-container">
                        <div class="col-md-10">
                            <h3 id="expertise-title">${firstBlock.content}</h3>
                            <p id="expertise-description"
                               data-content="expertise_description_${firstBlock.id}"
                               data-page="expertise"
                               data-type="textarea"
                               data-attribute="html">
                            </p>
                            <a id="expertise-learn-more" href="${firstLearnMoreHref}" class="${firstLearnMoreClass}">Дізнатися більше</a>
                        </div>
                        <div class="col-md-2 text-end">
                           ${ICON_LOGO_SVG}
                        </div>
                    </div>
                    <div class="row slide-content" id="images-container">
                        <div class="col-md-5"></div>
                        <div class="expertise-inner-image-container col-md-7 d-flex justify-content-center">
                            <img class="expertise-inner-image" data-content="expertise_inner_image_1_${firstBlock.id}"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 src="">
                            <img class="expertise-inner-image" data-content="expertise_inner_image_2_${firstBlock.id}"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 src="">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;

    return containerDiv;
}

function initSliderControls() {
    // Не инициализируем слайдер на мобильных устройствах
    if (isMobile()) {
        return;
    }

    const sliderContainer = document.querySelector('.expertise-slider-container');
    if (!sliderContainer) return;

    sliderContainer.addEventListener('click', (e) => {
        const navItem = e.target.closest('.slider-bar-element');
        if (navItem && !isAnimating) {
            const targetIndex = parseInt(navItem.dataset.slideIndex);
            if (targetIndex !== currentSlideIndex) {
                goToSlide(targetIndex);
            }
        }
    });
}

function goToSlide(targetIndex) {
    if (targetIndex < 0 || targetIndex >= expertisesData.length || targetIndex === currentSlideIndex || isAnimating) {
        return;
    }

    isAnimating = true;
    const targetBlock = expertisesData[targetIndex];
    const direction = targetIndex > currentSlideIndex ? 'up' : 'down';

    // Анимация ухода - едем вверх или вниз
    const slideContents = document.querySelectorAll('.slide-content');
    slideContents.forEach(content => {
        content.classList.add(`slide-${direction}`);
    });

    // Обновляем навигацию
    updateNavigation(targetIndex);

    // Ждем пока уедет
    setTimeout(() => {
        // Обновляем контент
        console.log('[Slider] Switching to slide:', targetIndex, targetBlock);

        document.getElementById('expertise-title').textContent = targetBlock.content;

        // Обновляем кнопку "Дізнатися більше"
        const learnMoreLink = document.getElementById('expertise-learn-more');
        if (learnMoreLink) {
            const newSlug = diagnosticSlugMap[targetBlock.id] || null;
            if (newSlug) {
                learnMoreLink.href = `/diagnostic/${newSlug}`;
                learnMoreLink.classList.remove('inactive');
                learnMoreLink.classList.add('active');
            } else {
                learnMoreLink.href = '#';
                learnMoreLink.classList.remove('active');
                learnMoreLink.classList.add('inactive');
            }
        }

        // Форсируем очистку старого контента перед обновлением
        const description = document.getElementById('expertise-description');
        const oldDescContent = description.getAttribute('data-content');
        const newDescContent = `expertise_description_${targetBlock.id}`;
        console.log('[Slider] Description:', oldDescContent, '->', newDescContent);
        description.innerHTML = ''; // Очищаем старый контент
        description.setAttribute('data-content', newDescContent);

        const innerImages = document.querySelectorAll('[data-content^="expertise_inner_image"]');
        innerImages.forEach((img, index) => {
            const oldContent = img.getAttribute('data-content');
            const newContent = `expertise_inner_image_${index + 1}_${targetBlock.id}`;
            console.log(`[Slider] Inner image ${index + 1}:`, oldContent, '->', newContent);
            img.src = ''; // Очищаем src у картинок
            img.setAttribute('data-content', newContent);
        });

        const mainImage = document.querySelector('.image-main-expertise');
        const oldMainContent = mainImage.getAttribute('data-content');
        const newMainContent = `expertise_main_image_${targetBlock.id}`;
        console.log('[Slider] Main image:', oldMainContent, '->', newMainContent);
        mainImage.src = ''; // Очищаем src у главной картинки
        mainImage.setAttribute('data-content', newMainContent);

        // Перезагружаем контент-редактор и ждем загрузки
        const newElements = document.querySelectorAll('[data-content]');
        if (newElements.length > 0) {
            console.log('[Slider] Reloading content for', newElements.length, 'elements');
            // Даем время контент-редактору подгрузить новые данные
            loadContentForNewElements(Array.from(newElements));

            // Добавляем небольшую задержку перед показом
            setTimeout(() => {
                // Продолжаем анимацию после загрузки контента
                continueSlideAnimation();
            }, 100);
        } else {
            continueSlideAnimation();
        }

        function continueSlideAnimation() {
            // Триггерим анимацию звезды при смене слайда
            triggerIconLogoAnimation();

            // Готовим элементы с противоположной стороны
            const prepareClass = direction === 'up' ? 'prepare-from-bottom' : 'prepare-from-top';
            slideContents.forEach(content => {
                content.classList.remove(`slide-${direction}`);
                content.classList.add(prepareClass);
            });

            // Запускаем въезд через маленькую задержку
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    slideContents.forEach(content => {
                        content.classList.remove(prepareClass);
                    });

                    // Разблокируем после анимации
                    setTimeout(() => {
                        isAnimating = false;
                    }, 600);
                });
            });
        }

    }, 600);

    currentSlideIndex = targetIndex;
}

function updateNavigation(activeIndex) {
    document.querySelectorAll('.slider-bar-element').forEach((item, index) => {
        const slideIndex = parseInt(item.dataset.slideIndex);
        if (slideIndex === activeIndex) {
            // Убираем класс active и добавляем снова для ретриггера анимации
            item.classList.remove('active');
            void item.offsetWidth; // Форсируем reflow
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
}

// Добавляем обработчик изменения размера окна
window.addEventListener('resize', () => {
    // Пересоздаем интерфейс при изменении размера окна
    if (expertisesData.length > 0) {
        const contents = expertisesData.map(block => block.content);

        if (isMobile()) {
            renderMobileExpertiseList(expertisesData);
        } else {
            renderExpertiseSlider(expertisesData, contents);
            initSliderControls();
        }

        initStarAnimations();
    }
});